<script setup>
import { ref, onMounted, nextTick } from 'vue'
import Header from '@/components/layouts/header.vue'
import Footer from '@/components/layouts/footer.vue'
import SocialSidebar from '@/components/social.vue'
import { useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints({
  mobile: 640,
  tablet: 768,
  desktop: 1024,
})

const isMobile = breakpoints.smaller('tablet')
const isLoading = ref(true)
const loadingScreenRef = ref(null)

onMounted(async () => {
  await nextTick()

  // Wait for images to load
  const checkImages = () => {
    const images = document.querySelectorAll('main img')

    if (images.length === 0) {
      // No images, just wait a bit for content to render
      setTimeout(() => {
        startLoadingOutro()
      }, 1500) // Minimum loading time to show the animation
      return
    }

    let loadedCount = 0
    let errorCount = 0

    const checkComplete = () => {
      if (loadedCount + errorCount >= images.length) {
        setTimeout(() => {
          startLoadingOutro()
        }, 1000) // Small delay before outro
      }
    }

    images.forEach(img => {
      if (img.complete) {
        loadedCount++
      } else {
        img.addEventListener('load', () => {
          loadedCount++
          checkComplete()
        })
        img.addEventListener('error', () => {
          errorCount++
          checkComplete()
        })
      }
    })

    checkComplete()
  }

  // Delay to ensure slot content is rendered
  setTimeout(checkImages, 200)
})

const startLoadingOutro = () => {
  if (loadingScreenRef.value) {
    loadingScreenRef.value.hideLoading()
  }
}

const onLoadingComplete = () => {
  isLoading.value = false
}
</script>

<template>
 
  <!-- Main Layout -->
  <div class="min-h-screen flex flex-col">
    <Header />
    <SocialSidebar whatsapp-number="6287820200031" instagram-url="https://instagram.com/bpkpenaburjakarta"
      youtube-url="https://www.youtube.com/@BPKPENABURJkt" tiktok-url="https://www.tiktok.com/@bpkpenaburjakarta"
      facebook-url="https://www.facebook.com/bpkpenaburjkt/?locale=id_ID" />
    <main class="overflow-x-hidden flex-1">
      <slot />
    </main>
    <Footer 
    whatsapp-number="6287820200031"
    instagram-url="https://instagram.com/bpkpenaburjakarta"
    youtube-url="https://www.youtube.com/@BPKPENABURJkt"
    tiktok-url="https://www.tiktok.com/@bpkpenaburjakarta"
    facebook-url="https://www.facebook.com/bpkpenaburjkt/?locale=id_ID"
  />
  </div>
</template>

<style scoped>
/* No additional styles needed - GSAP handles all animations */
</style>